import PropTypes from 'prop-types';
import React from 'react';

import { BulletSeparator } from '../separator';
import { TopCommentIcon } from '../icons';
import withTopCommentColor from '../../hoc/with-top-comment-color';
import withTranslate from '../../hoc/with-translate';
import styles from './top-comment.scss';

const TopCommentDesktop = ({ topCommentColor, t }) => (
  <div className={styles.topComment}>
    <BulletSeparator/>
    <span className={styles.topCommentLabel}>
      {t('comment.top-comment')}
    </span>
    <TopCommentIcon className="button-fill" color={topCommentColor}/>
  </div>
);

TopCommentDesktop.propTypes = {
  topCommentColor: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslate(withTopCommentColor(TopCommentDesktop));



// WEBPACK FOOTER //
// ./app/components/top-comment/top-comment-desktop.js